import { render, staticRenderFns } from "./GridDeleteButton.vue?vue&type=template&id=07650f6a&"
import script from "./GridDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./GridDeleteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports